module.exports = __webpack_public_path__ + "img/logo.5d3f045a.png";